module.exports = __webpack_public_path__ + "static/media/product1.577e1af6.jpg";